<div>Archivos adjuntos {{ totalImagenes }}/{{ totalContenedores }}</div>
<div class="accidentContainer">
  <div *ngFor="let elem of accidentDetail.adjuntos" class="element">
    <ng-container
      *ngIf="
        elem.type.startsWith(fileType.IMAGEN) ||
        elem.type.startsWith(fileType.IMAGEN_OLD)
      "
    >
      <img
        alt="{{ elem.status }}"
        [src]="elem.safeUrl"
        (click)="zoomImage(elem)"
      />
    </ng-container>

    <ng-container *ngIf="elem.type.startsWith(fileType.PDF)">
      <a [href]="elem.url" target="_blank" height="10%">Ver pdf</a>
    </ng-container>

    <ng-container *ngIf="elem.type.startsWith(fileType.AUDIO)">
      <audio controls [src]="elem.url"></audio>
    </ng-container>
  </div>
  <div *ngFor="let image of contenedoresSinUsarArray" class="element empty">
    <i class="fas fa-image"></i>
  </div>
</div>
